<!-- GROUP / CONTACT INFO SIDE PANEL -->
<div class="group-info-backdrop" [class.show]="isGroupInfoOpen" (click)="closeGroupInfoPanel()"></div>
<div class="group-info-panel" [class.open]="isGroupInfoOpen">
  <!-- Header -->
  <div class="group-info-header">
    <div class="d-flex align-items-center">
      @if (panelView === "info") {
      <button class="btn btn-icon mr-2" (click)="closeGroupInfoPanel()" style="padding: 0">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
      <h6 class="m-0" style="font-weight: 600">{{ isGroup ? 'Group Info' : 'Contact Info' }}</h6>
      }
      @if (panelView === "member") {
      <button class="btn btn-icon mr-2" (click)="backToGroupInfo()" style="padding: 0">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="19" y1="12" x2="5" y2="12"></line>
          <polyline points="12 19 5 12 12 5"></polyline>
        </svg>
      </button>
      <h6 class="m-0" style="font-weight: 600">Contact Info</h6>
      }
      @if (panelView === "add") {
      <button class="btn btn-icon mr-2" (click)="backToGroupInfo()" style="padding: 0">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="19" y1="12" x2="5" y2="12"></line>
          <polyline points="12 19 5 12 12 5"></polyline>
        </svg>
      </button>
      <h6 class="m-0" style="font-weight: 600">Add Members</h6>
      }
    </div>

    @if (isGroup && panelView === "info" && !isCurrentGroupExited) {
    @if (!isEditGroupMode) {
    <button class="btn btn-icon" (click)="editGroupInfo()" title="Edit Group">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
        <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
      </svg>
    </button>
    } @else {
    <button class="btn btn-link" style="font-weight: 600; color: #7d96d7; text-decoration: none"
      (click)="updateGroupInfo()">
      Done
    </button>
    }
    }
  </div>

  <div class="group-info-body custom-scroll">
    <!-- VIEW 1: GROUP / CONTACT INFO (Main) -->
    @if (panelView === "info") {
    <!-- Profile Section -->
    @if (!isGroup) {
    <div class="panel-group-profile">
      <div class="panel-group-img-container" style="cursor: default">
        <img [src]="singleUserProfileImg || 'assets/user-icon.png'" (error)="handleImageError($event)"
          class="panel-group-img" style="cursor: default" />
      </div>
      <div class="panel-group-name-section">
        <p class="panel-group-name">{{ singleChatUsername || singleUser?.displayName || singleUser?.userName ||
          singleUser?.name || 'User' }}</p>
        <div class="contact-status-row">
          @if (isChatUserOnline) {
          <span class="online-indicator-dot"></span>
          <span class="online-text">Online</span>
          } @else {
          <span class="offline-text">{{ chatUserStatus || singleUser?.status || 'Offline' }}</span>
          }
        </div>
      </div>
    </div>

    <!-- Contact Details (Bio, Username, Email, Phone) -->
    <div class="contact-details-card"
      *ngIf="singleUser?.about || singleUser?.bio || (chatUserStatus && chatUserStatus !== 'Offline' && chatUserStatus !== 'Online') || singleUser?.userName || singleUserEmail || singleUser?.phone || singleUser?.mobile">
      @if (singleUser?.about || singleUser?.bio || (chatUserStatus && chatUserStatus !== 'Offline' && chatUserStatus !==
      'Online')) {
      <div class="contact-detail-row">
        <div class="contact-detail-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="16" x2="12" y2="12"></line>
            <line x1="12" y1="8" x2="12.01" y2="8"></line>
          </svg>
        </div>
        <div class="contact-detail-content">
          <span class="detail-label">Bio</span>
          <span class="detail-value">{{ singleUser?.about || singleUser?.bio || chatUserStatus }}</span>
        </div>
      </div>
      }

      @if (singleUser?.userName) {
      <div class="contact-detail-row">
        <div class="contact-detail-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="4"></circle>
            <path d="M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-3.92 7.94"></path>
          </svg>
        </div>
        <div class="contact-detail-content">
          <span class="detail-label">Username</span>
          <span class="detail-value">&#64;{{ singleUser.userName }}</span>
        </div>
      </div>
      }

      @if (singleUserEmail) {
      <div class="contact-detail-row">
        <div class="contact-detail-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
            <polyline points="22,6 12,13 2,6"></polyline>
          </svg>
        </div>
        <div class="contact-detail-content">
          <span class="detail-label">Email</span>
          <span class="detail-value">{{ singleUserEmail }}</span>
        </div>
      </div>
      }

      @if (singleUser?.phone || singleUser?.mobile) {
      <div class="contact-detail-row">
        <div class="contact-detail-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path
              d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z">
            </path>
          </svg>
        </div>
        <div class="contact-detail-content">
          <span class="detail-label">Phone</span>
          <span class="detail-value">{{ singleUser.phone || singleUser.mobile }}</span>
        </div>
      </div>
      }
    </div>
    } @else {
    <!-- Group Profile Section -->
    <div class="panel-group-profile">
      @if (isEditGroupMode) {
      <div class="panel-group-img-container" (click)="fileInput.click()">
        <img [src]="
                    newGroupImage ||
                    groupChatProfileImg ||
                    'assets/group_chat.png'
                  " (error)="handleGroupImageError($event)" class="panel-group-img" />
        <div class="panel-image-edit-overlay">
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#fff"
            stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"></path>
            <circle cx="12" cy="13" r="4"></circle>
          </svg>
        </div>
        <input #fileInput type="file" (change)="onGroupImageSelected($event)" style="display: none" accept="image/*" />
      </div>
      <div class="edit-input-group">
        <label style="
                    font-size: 12px;
                    color: #7d96d7;
                    font-weight: 600;
                    margin-bottom: 0;
                  ">Group Name</label>
        <input type="text" [(ngModel)]="newGroupName" placeholder="Enter group name" maxlength="100" />
      </div>
      <div class="edit-input-group">
        <label style="
                    font-size: 12px;
                    color: #707579;
                    font-weight: 600;
                    margin-bottom: 0;
                  ">Description</label>
        <textarea [(ngModel)]="newDiscription" class="edit-desc-input" placeholder="Add group description" rows="1"
          (input)="autoGrowDescription($event)"></textarea>
      </div>
      } @else {
      <div class="panel-group-img-container" style="cursor: default">
        <img [src]="groupChatProfileImg || 'assets/group_chat.png'" (error)="handleGroupImageError($event)"
          class="panel-group-img" style="cursor: default" />
      </div>
      <div class="panel-group-name-section">
        <p class="panel-group-name">{{ groupChatName }}</p>
        <p class="panel-group-count">
          {{ totalGroupMembers }}
          {{ totalGroupMembers === 1 ? "member" : "members" }}
        </p>
        @if (groupChatDescription && groupChatDescription.trim() !== '') {
        <div class="group-description-container">
          <p class="panel-group-description" [class.collapsed]="!isDescriptionExpanded && isDescriptionLong"
            [innerHTML]="formattedGroupDescription">
          </p>
          @if (isDescriptionLong) {
          <button type="button" class="btn-toggle-description" (click)="toggleDescription($event)">
            {{ isDescriptionExpanded ? 'Show less' : 'Read more' }}
          </button>
          }
        </div>
        }
      </div>
      }
    </div>
    }

    <!-- SHARED CONTENT SECTION (Media, Files, Audio, GIFS, Links) -->
    @if (!isEditGroupMode) {
    <div class="shared-section-container">
      <div class="shared-section-header">
        <div class="shared-tabs-nav custom-scroll-x">
          @if (isGroup) {
          <button type="button" class="shared-tab-btn" [class.active]="selectedSharedTab === 'members'"
            (click)="selectedSharedTab = 'members'">
            <span>Members</span>
          </button>
          }
          <button type="button" class="shared-tab-btn" [class.active]="selectedSharedTab === 'media'"
            (click)="selectedSharedTab = 'media'">
            <span>Media</span>
          </button>
          <button type="button" class="shared-tab-btn" [class.active]="selectedSharedTab === 'files'"
            (click)="selectedSharedTab = 'files'">
            <span>Files</span>
          </button>
          <button type="button" class="shared-tab-btn" [class.active]="selectedSharedTab === 'audio'"
            (click)="selectedSharedTab = 'audio'">
            <span>Audio</span>
          </button>
          <button type="button" class="shared-tab-btn" [class.active]="selectedSharedTab === 'gifs'"
            (click)="selectedSharedTab = 'gifs'">
            <span>GIFS</span>
          </button>
          <button type="button" class="shared-tab-btn" [class.active]="selectedSharedTab === 'links'"
            (click)="selectedSharedTab = 'links'">
            <span>Links</span>
          </button>
        </div>
      </div>

      <div class="shared-tab-content">
        <!-- TAB 0: MEMBERS (Group only) -->
        @if (isGroup && selectedSharedTab === 'members') {
        <div class="group-members-tab-content">
          <!-- Members Search -->
          @if (!isEditGroupMode) {
          <div class="px-3 py-2">
            <input type="text" [(ngModel)]="groupMemberSearchQuery" placeholder="Search members..."
              class="form-control member-search-input" style="
                        border-radius: 20px;
                        background: #f0f2f5;
                        border: none;
                        font-size: 14px;
                      " />
          </div>
          }
          <!-- Members Section Title -->
          <div class="panel-section-title d-flex justify-content-between align-items-center">
            <span>{{ activeGroupMembersCount }} Members</span>
          </div>

          <!-- Add Member (Admin only) -->
          @if (isAdmin(userId) && !isEditGroupMode && !isCurrentGroupExited) {
          <div class="panel-member-item" (click)="openAddMembersView()">
            <div class="panel-member-info">
              <div class="rounded-circle d-flex align-items-center justify-content-center mr-3 add-member-icon-circle"
                style="
                          width: 40px;
                          height: 40px;
                          background: #eef2ff;
                          color: #7d96d7;
                        ">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="12" cy="12" r="10"></circle>
                  <line x1="12" y1="8" x2="12" y2="16"></line>
                  <line x1="8" y1="12" x2="16" y2="12"></line>
                </svg>
              </div>
              <span style="font-weight: 500; color: #7d96d7">Add Members</span>
            </div>
          </div>
          }

          <!-- Member List -->
          <div class="d-flex flex-column">
            @for (member of getFilteredGroupMembers(); track member.userId) {
            <div class="panel-member-item" (click)="openMemberInfo(member)">
              <div class="panel-member-info">
                <img [src]="member.profileImage || 'assets/user-icon.png'" (error)="handleImageError($event)"
                  class="rounded-circle mr-3" style="width: 40px; height: 40px; object-fit: cover" />
                <div>
                  <p class="mb-0 member-name-text" style="font-weight: 500">
                    {{
                    member.userId === userId
                    ? "You"
                    : member.displayName || member.userName
                    }}
                  </p>
                  @if (member.isAdmin) {
                  <p class="mb-0 text-muted" style="font-size: 12px; color: #7d96d7 !important">
                    Admin
                  </p>
                  }
                </div>
              </div>
            </div>
            }
            @if (getFilteredGroupMembers().length === 0) {
            <div class="text-center py-4 text-muted" style="font-size: 13px;">
              No members found
            </div>
            }
          </div>

          <!-- Group Actions (Exit, Clear, Delete) inside Member tab -->
          <!-- <div class="group-tab-actions-divider"></div> -->
          <div class="panel-action-list group-tab-action-list">
            @if (!isCurrentGroupExited) {
            <div class="panel-action-btn delete" (click)="exitGroup()">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                <polyline points="16 17 21 12 16 7"></polyline>
                <line x1="21" y1="12" x2="9" y2="12"></line>
              </svg>
              <span>Exit Group</span>
            </div>
            }

            @if (!isCurrentGroupExited) {
            <div class="panel-action-btn delete" (click)="clearChat()">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" viewBox="0 0 24 24">
                <g fill="none">
                  <path d="M2.5 3h19v14h-15l-4 3.5z" />
                  <path stroke="#dc3545" stroke-linecap="square" stroke-width="1.4"
                    d="M2.5 3h19v14h-15l-4 3.5zm12.329 4.172L12 10m0 0l-2.828 2.828M12 10l2.829 2.828M12 10L9.172 7.172" />
                </g>
              </svg>
              <span>Clear Chat</span>
            </div>
            }

            <div class="panel-action-btn delete" (click)="removeFromMyChats()">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="3 6 5 6 21 6"></polyline>
                <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
              </svg>
              <span>Remove from my chats</span>
            </div>

            @if (isLinkAdmin) {
            <div class="panel-action-btn delete" (click)="deleteGroupChat()">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="3 6 5 6 21 6"></polyline>
                <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                <line x1="10" y1="11" x2="10" y2="17"></line>
                <line x1="14" y1="11" x2="14" y2="17"></line>
              </svg>
              <span>Delete for everyone</span>
            </div>
            }
          </div>
          <div style="height: 30px"></div>
        </div>
        }

        <!-- TAB 1: MEDIA (Photos & Videos) -->
        @if (selectedSharedTab === 'media') {
        @if (sharedMedia.length > 0) {
        <div class="shared-media-grid custom-scroll">
          @for (item of sharedMedia; track (item.url + $index)) {
          <div class="shared-media-item" (click)="onMediaClick(item)" [title]="item.name || 'View media'">
            <img [src]="item.thumbnailUrl || item.url" class="shared-media-thumb" alt="media" loading="lazy"
              (error)="$any($event.target).style.display='none'" />
            @if (item.type === 'video') {
            <div class="video-play-badge">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="white">
                <polygon points="5 3 19 12 5 21 5 3"></polygon>
              </svg>
            </div>
            }
          </div>
          }
        </div>
        } @else {
        <div class="shared-empty-state">
          <div class="empty-icon-circle">
            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none"
              stroke="#7d96d7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
              <circle cx="8.5" cy="8.5" r="1.5"></circle>
              <polyline points="21 15 16 10 5 21"></polyline>
            </svg>
          </div>
          <p class="empty-title">No shared media</p>
          <p class="empty-desc">Photos and videos shared in this chat will appear here.</p>
        </div>
        }
        }

        <!-- TAB 2: FILES -->
        @if (selectedSharedTab === 'files') {
        @if (sharedFiles.length > 0) {
        <div class="shared-files-list custom-scroll">
          @for (file of sharedFiles; track (file.url + $index)) {
          <div class="shared-file-row" (click)="onPreviewFile(file, $event)" [title]="'Preview ' + file.name">
            <div class="file-icon-badge" [style.background]="file.color">
              <span>{{ file.label }}</span>
            </div>
            <div class="file-info-col">
              <span class="file-name-text text-truncate">{{ file.name }}</span>
              <span class="file-meta-text">
                <span *ngIf="file.size">{{ file.size }} &bull; </span>
                <span>{{ formatDate(file.date) }}</span>
              </span>
            </div>
            <button type="button" class="file-download-btn" (click)="onDownloadFile(file, $event)" title="Download">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                <polyline points="7 10 12 15 17 10"></polyline>
                <line x1="12" y1="15" x2="12" y2="3"></line>
              </svg>
            </button>
          </div>
          }
        </div>
        } @else {
        <div class="shared-empty-state">
          <div class="empty-icon-circle">
            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none"
              stroke="#7d96d7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
              <polyline points="14 2 14 8 20 8"></polyline>
              <line x1="16" y1="13" x2="8" y2="13"></line>
              <line x1="16" y1="17" x2="8" y2="17"></line>
              <polyline points="10 9 9 9 8 9"></polyline>
            </svg>
          </div>
          <p class="empty-title">No shared files</p>
          <p class="empty-desc">Documents and files shared in this chat will appear here.</p>
        </div>
        }
        }

        <!-- TAB 3: AUDIO -->
        @if (selectedSharedTab === 'audio') {
        @if (sharedAudio.length > 0) {
        <div class="shared-audio-list custom-scroll">
          @for (audioItem of sharedAudio; track (audioItem.url + $index)) {
          <div class="shared-audio-row">
            <button type="button" class="audio-play-btn" (click)="toggleAudioPlayback(audioItem)"
              [class.playing]="isPlayingAudio && currentPlayingAudioUrl === audioItem.url" title="Play audio">
              @if (isPlayingAudio && currentPlayingAudioUrl === audioItem.url) {
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                <rect x="6" y="4" width="4" height="16"></rect>
                <rect x="14" y="4" width="4" height="16"></rect>
              </svg>
              } @else {
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                <polygon points="5 3 19 12 5 21 5 3"></polygon>
              </svg>
              }
            </button>
            <div class="audio-info-col">
              <span class="audio-title text-truncate">{{ audioItem.name }}</span>
              <div class="audio-progress-container" *ngIf="isPlayingAudio && currentPlayingAudioUrl === audioItem.url">
                <div class="audio-progress-bar" [style.width.%]="audioProgress"></div>
              </div>
              <span class="audio-meta-text">
                <span *ngIf="isPlayingAudio && currentPlayingAudioUrl === audioItem.url">{{ audioCurrentTime }} &bull;
                </span>
                <span *ngIf="audioItem.duration">{{ audioItem.duration }} &bull; </span>
                <span>{{ formatDate(audioItem.date) }}</span>
              </span>
            </div>
            <button type="button" class="audio-download-btn" (click)="onDownloadFile(audioItem, $event)"
              title="Download audio">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                <polyline points="7 10 12 15 17 10"></polyline>
                <line x1="12" y1="15" x2="12" y2="3"></line>
              </svg>
            </button>
          </div>
          }
        </div>
        } @else {
        <div class="shared-empty-state">
          <div class="empty-icon-circle">
            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none"
              stroke="#7d96d7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M9 18V5l12-2v13"></path>
              <circle cx="6" cy="18" r="3"></circle>
              <circle cx="18" cy="16" r="3"></circle>
            </svg>
          </div>
          <p class="empty-title">No shared audio</p>
          <p class="empty-desc">Voice notes and audio files shared in this chat will appear here.</p>
        </div>
        }
        }

        <!-- TAB 4: GIFS -->
        @if (selectedSharedTab === 'gifs') {
        @if (sharedGifs.length > 0) {
        <div class="shared-gifs-grid custom-scroll">
          @for (gif of sharedGifs; track (gif.url + $index)) {
          <div class="shared-gif-item" (click)="onGifClick(gif)" title="View GIF">
            <img [src]="gif.url" class="shared-gif-img" alt="GIF" loading="lazy" />
            <span class="gif-badge">GIF</span>
          </div>
          }
        </div>
        } @else {
        <div class="shared-empty-state">
          <div class="empty-icon-circle">
            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none"
              stroke="#7d96d7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
              <circle cx="8.5" cy="8.5" r="1.5"></circle>
              <polyline points="21 15 16 10 5 21"></polyline>
            </svg>
          </div>
          <p class="empty-title">No shared GIFs</p>
          <p class="empty-desc">Animated GIFs shared in this chat will appear here.</p>
        </div>
        }
        }

        <!-- TAB 5: LINKS -->
        @if (selectedSharedTab === 'links') {
        @if (sharedLinks.length > 0) {
        <div class="shared-links-list custom-scroll">
          @for (link of sharedLinks; track (link.url + $index)) {
          <div class="shared-link-row" (click)="onLinkClick(link, $event)" [title]="link.url">
            <div class="link-thumb-box">
              @if (link.image) {
              <img [src]="link.image" class="link-thumb-img" alt="preview"
                (error)="$any($event.target).style.display='none'" />
              } @else {
              <div class="link-placeholder-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                  stroke="#7d96d7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="12" cy="12" r="10"></circle>
                  <line x1="2" y1="12" x2="22" y2="12"></line>
                  <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z">
                  </path>
                </svg>
              </div>
              }
            </div>
            <div class="link-info-col">
              <span class="link-title-text text-truncate">{{ link.title || link.domain || link.url }}</span>
              <p class="link-desc-text" *ngIf="link.description">{{ link.description }}</p>
              <span class="link-domain-text text-truncate">{{ link.domain || link.url }} &bull; {{ formatDate(link.date)
                }}</span>
            </div>
            <div class="link-external-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                <polyline points="15 3 21 3 21 9"></polyline>
                <line x1="10" y1="14" x2="21" y2="3"></line>
              </svg>
            </div>
          </div>
          }
        </div>
        } @else {
        <div class="shared-empty-state">
          <div class="empty-icon-circle">
            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none"
              stroke="#7d96d7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path>
              <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>
            </svg>
          </div>
          <p class="empty-title">No shared links</p>
          <p class="empty-desc">Links and web pages shared in this chat will appear here.</p>
        </div>
        }
        }
      </div>
    </div>
    }

    <!-- Single Chat Actions (Clear Chat) -->
    @if (!isGroup) {
    <div style="height: 20px"></div>
    <div class="panel-action-list" style="border-top: 10px solid #f0f2f5">
      <div class="panel-action-btn delete pl-4" (click)="onClearSingleChat()">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" viewBox="0 0 24 24">
          <g fill="none">
            <path d="M2.5 3h19v14h-15l-4 3.5z" />
            <path stroke="#dc3545" stroke-linecap="square" stroke-width="1.4"
              d="M2.5 3h19v14h-15l-4 3.5zm12.329 4.172L12 10m0 0l-2.828 2.828M12 10l2.829 2.828M12 10L9.172 7.172" />
          </g>
        </svg>
        Clear Chat
      </div>
    </div>
    <div style="height: 50px"></div>
    }
    }

    <!-- VIEW 2: MEMBER INFO  -->
    @if (panelView === "member" && viewingMember) {
    <div class="panel-group-profile">
      <div class="panel-group-img-container" style="cursor: default">
        <img [src]="
                  viewingMember.profileImage || 'assets/user-icon.png'
                " (error)="handleImageError($event)" class="panel-group-img" style="cursor: default" />
      </div>
      <div class="panel-group-name-section">
        <p class="panel-group-name">
          {{
          viewingMember.userId === userId
          ? "You"
          : viewingMember.displayName || viewingMember.userName
          }}
        </p>
        @if (viewingMember.status || viewingMember.about) {
        <p class="text-muted mt-2 mb-0" style="font-size: 14px">
          {{ viewingMember.status || viewingMember.about }}
        </p>
        }
        @if (viewingMember.isAdmin) {
        <span class="badge badge-primary mt-2" style="
                    background-color: #eef2ff;
                    color: #7d96d7;
                    border: 1px solid #7d96d7;
                    font-weight: 500;
                  ">Group Admin</span>
        }
      </div>
    </div>

    <div class="panel-section-title">Actions</div>

    <div class="d-flex flex-column">
      @if (viewingMember.userId !== userId) {
      <div class="panel-action-btn" (click)="onMessage(viewingMember)">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
        </svg>
        Message
        {{ viewingMember.displayName || viewingMember.userName }}
      </div>
      }

      @if (viewingMember.userId === userId) {
      @if (!isCurrentGroupExited) {
      <div class="panel-action-btn delete" (click)="clearChat()">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" viewBox="0 0 24 24">
          <g fill="none">
            <path d="M2.5 3h19v14h-15l-4 3.5z" />
            <path stroke="#dc3545" stroke-linecap="square" stroke-width="1.4"
              d="M2.5 3h19v14h-15l-4 3.5zm12.329 4.172L12 10m0 0l-2.828 2.828M12 10l2.829 2.828M12 10L9.172 7.172" />
          </g>
        </svg>
        Clear Chat
      </div>
      }
      @if (!isCurrentGroupExited) {
      <div class="panel-action-btn delete" (click)="exitGroup()">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
          <polyline points="16 17 21 12 16 7"></polyline>
          <line x1="21" y1="12" x2="9" y2="12"></line>
        </svg>

        Exit Group
      </div>
      }
      }

      @if (
      isAdmin(userId) &&
      viewingMember.userId !== userId &&
      !isCurrentGroupExited
      ) {
      @if (!viewingMember.isAdmin) {
      <div class="panel-action-btn" (click)="makeMemberAdmin(viewingMember)">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#7d96d7"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
        </svg>
        Make Group Admin
      </div>
      } @else {
      <div class="panel-action-btn delete" (click)="dismissGroupAdmin(viewingMember)">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#dc3545"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="15" y1="9" x2="9" y2="15"></line>
          <line x1="9" y1="9" x2="15" y2="15"></line>
        </svg>
        Dismiss as Admin
      </div>
      }

      <div class="panel-action-btn delete" (click)="removeMemberFromGroup(viewingMember)">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
          <circle cx="8.5" cy="7" r="4"></circle>
          <line x1="23" y1="11" x2="17" y2="11"></line>
        </svg>
        Remove from Group
      </div>
      }
    </div>
    }

    <!-- VIEW 3: ADD MEMBERS  -->
    @if (panelView === "add") {
    <!-- Search Box -->
    <div class="p-3">
      <input type="text" [(ngModel)]="addMemberSearchTerm" placeholder="Search users..." class="form-control"
        style="border-radius: 20px; background: #f0f2f5; border: none" />
    </div>

    <!-- User List -->
    <div class="d-flex flex-column" style="padding-bottom: 5rem">
      @for (user of filteredAvailableUsersForAdd; track user.userId) {
      <div class="panel-member-item" (click)="toggleNewMemberSelection(user)">
        <div class="panel-member-info">
          <img [src]="user.profileImage || 'assets/user-icon.png'" (error)="handleImageError($event)"
            class="rounded-circle mr-3" style="width: 40px; height: 40px; object-fit: cover" />
          <div>
            <p class="mb-0" style="font-weight: 500">
              {{ user.displayName || user.userName }}
            </p>
          </div>
        </div>
        <!-- Checkbox -->
        <div class="selection-checkbox" [class.selected]="selectedNewMembers.includes(user)"
          style="border-radius: 50%; width: 24px; height: 24px">
          @if (selectedNewMembers.includes(user)) {
          <span class="checked-icon text-white">✓</span>
          }
        </div>
      </div>
      }
    </div>

    <!-- Floating Action Button for Add -->
    <div class="floating-action-container" style="position: absolute; bottom: 32px; right: 20px">
      <button class="floating-btn success-btn" (click)="addSelectedMembersToGroup()"
        [disabled]="isAddingMember || selectedNewMembers.length === 0">
        @if (isAddingMember) {
        <span class="loader-sm"><span class="dot"></span></span>
        } @else {
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="12" y1="5" x2="12" y2="19"></line>
          <line x1="5" y1="12" x2="19" y2="12"></line>
        </svg>
        }
      </button>
    </div>
    }

  </div>
</div>